// extracted by mini-css-extract-plugin
export default {"headSelectIcon":"headSelectIcon_U4BSm","lang_box":"lang_box_G_oQ5","langBtn":"langBtn_mnOvR","langActive":"langActive_ikkbz","head_portrait_box":"head_portrait_box_imBhx"};